import { styled } from "@mui/material";

interface ComponentProps {
    id?: number;
    name: string;
    examAmount: number;
    exemptionAmount: number;
    routeId: number;
    isActive?: boolean;
  }

const ViewContent : React.FC<ComponentProps> = ({ name, examAmount, exemptionAmount, routeId }) => {
    return (
        <StyledContainer>
            <StyledWrapper>
                <StyledText>Name</StyledText>
                <Active>{name}</Active>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Exam Amount</StyledText>
                <StyledDate> {examAmount}</StyledDate>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Exemption Amount</StyledText>
                <StyledDate> {exemptionAmount}</StyledDate>
            </StyledWrapper>
            {/* <StyledWrapper>
                <StyledText2>Exemption Amount</StyledText2>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>{exemptionAmount}</StyledText>
            </StyledWrapper> */}
        </StyledContainer>
    )
}

export default ViewContent;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`
const StyledText2 = styled('span')`
    font-size: 24px;
    font-weight: 500;
    color: #020D08;
    width:100%
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`